var scope_0 = require('/home/circleci/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/00d76f7c1f4454c44c01f5df93cddf30.js').default;
var scope_1 = require('/home/circleci/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/010035100746a6d9e64a2e36f97779e5.js').default;
var scope_2 = require('/home/circleci/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1c46cd5a142953b239fb9c5396ca7388.js').default;
var scope_3 = require('/home/circleci/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8e3cbe7b6d4a922ccdf834e21d2a4eed.js').default;
var scope_4 = require('/home/circleci/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c751bfdb0b6d5cb95145c9de48ff4592.js').default;
var scope_5 = require('/home/circleci/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_6 = require('/home/circleci/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fd3305611efa278f14617833f8a99ba2.js').default;
var scope_7 = require('/home/circleci/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ff87224b50288ce107e3ab7213f77fdd.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7 )
    